import styled from "styled-components";

export const SpacerAndDividerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ hasContent = true }) => (hasContent ? "10px" : "0px")};
  width: ${({ width }) => `${width}%`};
`;

export const SpacerAndDividerLine = styled.div`
  width: 100%;
  height: ${({ height }) => `${height}px`};
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const SpacerAndDividerContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SpacerAndDividerIconContainer = styled.div`
  color: ${({ color }) => color};
`;

export const SpacerAndDividerSpan = styled.span`
  font-size: ${({ fontSize }) => `${fontSize}px`};
  color: ${({ theme }) => theme.text.input};
  white-space: nowrap;
`;
